// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { SearchResultVO } from '@project/components/article/model/vo/search-result.vo';

@JsonObject('ArticleSearchResultVO')
export class ArticleSearchResultVO extends SearchResultVO {

  public static readonly CLASS_NAME: string = 'ArticleSearchResultVO';

  @JsonProperty('articles', 'ArticleVOsConverter', true)
  public articles: ArticleVO[] = undefined;

  public constructor() {
    super();
    this.type = ArticleSearchResultVO.CLASS_NAME;
  }
}
